import { useQuery } from '@tanstack/react-query';
import type { EarliestStagedDateDto } from '@signalvote/shared';
import { authService } from '../../services/authService';
import { apiJson } from './apiFetch';
import { queryKeys } from '../../lib/queryKeys';

export function useEarliestStagedDate() {
  return useQuery({
    queryKey: queryKeys.finance.earliestStagedDate(),
    queryFn: () =>
      apiJson<EarliestStagedDateDto>('/api/finance/staged/earliest-date', {
        error: 'Failed to fetch earliest staged date',
      }),
    enabled: authService.isAuthenticated(),
    staleTime: 60_000,
  });
}
